import { render } from "./OnlineCompletePage.vue?vue&type=template&id=6ca2567c&scoped=true&ts=true"
import script from "./OnlineCompletePage.vue?vue&type=script&lang=ts"
export * from "./OnlineCompletePage.vue?vue&type=script&lang=ts"

import "./OnlineCompletePage.vue?vue&type=style&index=0&id=6ca2567c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca2567c"]])

export default __exports__